import $ from 'mdui.jq/es/$';

const $document = $(document);
const $window = $(window);
const $body = $('body');

export { $document, $window, $body };
